import React from 'react';
import styles from '../rfstore_10/rfstore_10.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado4 from '../../components/LinkPersonalizado4/linkPersonalizado4.tsx';

const Rfstore_10: React.FC = () => {

    return (
        <div className={styles.rfstore_10}>

            <div className={styles["body-thunder"]}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mb-0">RF STORE</h1>
                    <span className={styles["subtitle"]}>APPLE AO SEU ALCANCE</span>
                    <div className={styles.links}>
                        <LinkPersonalizado4
                            href="https://wa.me/5517981564067?text=Olá, gostaria de mais informações."
                            title="WHATSAPP"
                            colorText="#fff"
                            borderColor="#00758b"
                        />
                        <LinkPersonalizado4
                            href="https://www.instagram.com/rfstore.10?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            colorText="#fff"
                            borderColor="#00758b"
                        />
                        <LinkPersonalizado4
                            href="https://maps.app.goo.gl/3eT2exM66xAhh5Yy5"
                            title="LOCALIZAÇÃO"
                            colorText="#fff"
                            borderColor="#00758b"
                        />
                    </div>
                    <div className="mt-2">
                        <img width="100%" src={require("./src/logo_footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rfstore_10;
